import React from "react";
import './style/main.css'
function Faq() {

    return (
        <React.Fragment>
            <div className="faq">
                <div className="container">
                    <h1>FAQ</h1>
                </div>
            </div>
        </React.Fragment>
    )
}

export default Faq;